import { Link } from 'gatsby'
import { LogoWrapper } from './style'
import LogoSvg from '../../assets/images/logo/dark-logo.svg'
import { usePageContext } from '@context/PageContext'

const Logo = ({ className, variant = 'dark', ...restProps }) => {
  const { locale } = usePageContext()

  return (
    <LogoWrapper className={className} $variant={variant} {...restProps}>
      <Link to={`/${locale}`}>
        <img src={LogoSvg} className="dark-logo" alt="logo" title="BSW" />
        <img
          src={LogoSvg}
          className="light-logo"
          alt="logo"
          title="BSW"
          style={{ width: 160, height: 48 }}
        />
      </Link>
    </LogoWrapper>
  )
}

export default Logo
